import { Link } from 'react-router-dom';
import { siteName } from '@/mocks/home';

const footerColumns = [
  {
    title: '投稿通道',
    links: [
      { label: '投稿入口', to: '/submit' },
      { label: '匿名投稿说明', to: '/guide#anonymous' },
      { label: '私信爆料渠道', to: '/guide#private' },
      { label: '线索征集范围', to: '/#categories' },
    ],
  },
  {
    title: '了解我们',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '内容原则', to: '/about#principles' },
      { label: '投稿流程', to: '/#flow' },
      { label: '联系我们', to: '/about#contact' },
    ],
  },
  {
    title: '投稿前必读',
    links: [
      { label: '常见问题', to: '/guide#faq' },
      { label: '证据与材料要求', to: '/guide#evidence' },
      { label: '时间线说明', to: '/guide#timeline' },
      { label: '隐私保护政策', to: '/guide#privacy' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50 text-primary-950 font-heading text-2xl leading-none">
                17
              </span>
              <span className="font-heading text-2xl text-background-50 tracking-wide">{siteName}</span>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-200 max-w-md">
              一个专注娱乐与网络热点线索的投稿平台。我们接收匿名投稿、私信爆料与公开素材，
              做的是把零散的线索认真核实、整理成可读内容的活儿。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-100 whitespace-nowrap">
                匿名投稿
              </span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-100 whitespace-nowrap">
                私信爆料
              </span>
              <span className="px-3 py-1.5 rounded-full bg-background-50/10 text-xs text-background-100 whitespace-nowrap">
                线索征集
              </span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="text-sm font-bold text-background-50 mb-4">
                <Link to="/" className="cursor-pointer hover:text-accent-300 transition-colors">
                  {col.title}
                </Link>
              </h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.to}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1" />
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-300">
            © 2026 {siteName} · 线索投稿与内容整理平台
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-300">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-mail-send-line"></i>
              投稿邮箱：tougao@17chigua.example
            </span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-shield-check-line"></i>
              投稿人身份严格保密
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}